<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { CSAT_RATINGS } from 'shared/constants/messages';
import { useMessageContext } from '../provider.js';
import store from '../../../store';

const { contentAttributes, inboxId } = useMessageContext();
const response = computed(() => {
  return contentAttributes.value?.submittedValues?.csatSurveyResponse ?? {};
});

const isRatingSubmitted = computed(() => {
  return !!response.value.rating;
});

const rating = computed(() => {
  if (isRatingSubmitted.value) {
    return CSAT_RATINGS.find(
      csatOption => csatOption.value === response.value.rating
    );
  }

  return null;
});

const inbox = computed(() => store.getters['inboxes/getInbox'](inboxId.value));
const locale = computed(() => inbox.value.csat_locale);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="csat">
    <h4>{{ $t('CONVERSATION.CSAT_REPLY_MESSAGE', {}, { locale: locale }) }}</h4>
    <dl v-if="isRatingSubmitted" class="mt-4">
      <dt class="text-n-slate-11 italic">
        {{ $t('CONVERSATION.RATING_TITLE', {}, { locale: locale }) }}
      </dt>
      <dd>{{ $t(rating.translationKey, {}, { locale: locale }) }}</dd>

      <dt v-if="response.feedbackMessage" class="text-n-slate-11 italic mt-2">
        {{ $t('CONVERSATION.FEEDBACK_TITLE', {}, { locale: locale }) }}
      </dt>
      <dd>{{ response.feedbackMessage }}</dd>
    </dl>
  </BaseBubble>
</template>
